import PropTypes from 'prop-types';

export const props = {
  t: PropTypes.func,
};
